module.exports = __webpack_public_path__ + "img/about8.41c223e2.png";